import React, { Component } from "react";
import {
  MDBContainer, MDBNavbar,  MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBFormInline,
  MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon
} from "mdbreact";
import { Link } from 'gatsby';
import CustomNavLink from './customLink';
//import { ReactComponent as Logo } from "../images/light-bulb.svg";
import Logo from "../images/fd-logo-50.png";

class NavbarPage extends Component {
  state = {
    isOpen: false
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <MDBNavbar light expand="md">
        <MDBContainer>
          <img src={Logo}/>
          <Link to="/" className="navbar-brand">
          </Link>
          <MDBNavbarToggler name="navbar-toggler" onClick={this.toggleCollapse} style={{ color: 'white' }} />
          <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
            <MDBNavbarNav right className="white-text">
                <CustomNavLink className="px-3 pointer" to="#!">Home</CustomNavLink>
                <CustomNavLink className="px-3 pointer" to="/services">What we do</CustomNavLink>
                <CustomNavLink className="px-3 pointer" to="/work">Our Work</CustomNavLink>
                <CustomNavLink className="px-3 pointer" to="/contact">Contact</CustomNavLink>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    );
  }
}

export default NavbarPage;
